// API Configuration
// Use environment variable or fallback to localhost for development
const API_BASE_URL = process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:8000';

export default API_BASE_URL;
